import React, { useState } from "react";
import Styles from "./styles.module.scss";
import H2 from "../../../../components/typography/h2";
import H3 from "../../../../components/typography/h3";
import bannerimg from "../../../../assets/newhomepageimg/socialmedia/bannerimg.webp";
import serviceimage1 from "../../../../assets/newhomepageimg/socialmedia/serviceimage1.webp";
import serviceimage2 from "../../../../assets/newhomepageimg/socialmedia/serviceimage2.webp";
import serviceimage3 from "../../../../assets/newhomepageimg/socialmedia/serviceimage3.webp";
import serviceimage4 from "../../../../assets/newhomepageimg/socialmedia/serviceimage4.webp";
import serviceimage5 from "../../../../assets/newhomepageimg/socialmedia/serviceimage5.webp";
import serviceimage6 from "../../../../assets/newhomepageimg/socialmedia/serviceimage6.webp";
import { FaPlus, FaMinus } from "react-icons/fa";
import Processimg from "../../../../assets/newhomepageimg/socialmedia/processimg.webp"
const SocialMediaMarketing = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null); // Collapse if already active
    } else {
      setActiveIndex(index);
    }
  };

  const services = [
    {
      title: "Profile Optimization",
      description:
        "We help your brand stay active and engaging on social media through profile optimization, content creation, planning.",
      image: serviceimage1,
    },
    {
      title: "Social Media Planning",
      description:
        "We plan your content and posting strategy to keep your brand active, consistent, and engaging.",
      image: serviceimage2,
    },
    {
      title: "Content Creation",
      description:
        "We create scroll-stopping content that reflects your brand and engages your audience across platforms.",
      image: serviceimage3,
    },
    {
      title: "Community Management",
      description:
        "We manage your online community by responding, engaging, and building meaningful bonds with your audience.",
      image: serviceimage4,
    },
    {
      title: "Graphic Designing",
      description:
        "We make visually appealing designs that align with your brand and make your content stand out across all social media.",
      image: serviceimage5,
    },
    {
      title: "Posting & Scheduling",
      description:
        "WWe schedule and publish your content at the right time to maximize reach, consistency, and engagement.",
      image: serviceimage6,
    },
  ];

  const accordionData = [
    {
      title: "Strategy & Planning",
      content:
        "We analyze your brand's goals and create a social media roadmap tailored for success.",
    },
    {
      title: "Creative Development",
      content:
        "We design posts, stories, and campaigns that align with your brand identity.",
    },
    {
      title: "Publishing & Scheduling",
      content: "We schedule content for optimal engagement and visibility.",
    },
    {
      title: "Community Engagement",
      content:
        "We manage responses and interactions to build a loyal following.",
    },
    {
      title: "Monitoring & Reporting",
      content: "We provide analytics and insights to improve performance.",
    },
    {
      title: "Paid Campaign Management (Optional)",
      content:
        "We manage ad campaigns to reach wider audiences with precision.",
    },
  ];
const [activeFaq, setActiveFaq] = useState(null);

const faqData = [
  {
    question: "What is digital marketing, and how can it help my business?",
    answer: "Digital marketing promotes your business online using tools like social media, SEO, and email to increase visibility and sales."
  },
  {
    question: "How long does it take to see results from digital marketing?",
    answer: "You may start seeing early signs in 1-3 months, but significant ROI usually builds over 3–6 months."
  },
  {
    question: "Will I receive reports and updates?",
    answer: "Yes, we provide regular performance updates with key metrics and next-step recommendations."
  },
  {
    question: "What platforms do you work with?",
    answer: "We work with Instagram, Facebook, LinkedIn, Google Ads, YouTube, and more depending on your audience."
  },
];

  return (
    <>
      <div className="container">
        <div className={Styles.project_info}>
        <div className={Styles.breadcrumb}>
  <a href="/" ><span>
 Home
</span>
</a>
<span className={Styles.separator}>/</span>
 <span>
 Services
</span>
  <span className={Styles.separator}>/</span>
  <span className={Styles.active}>Digital Marketing</span>
</div>

          <div style={{ marginTop: "80px" }}>
            <H3>
              <span>Grow </span>
              <span>your brand</span>
              <span> and connect </span>
              <span> with customers</span>
              <span> through</span>
              <span>Social Media.</span>
            </H3>
          </div>
        </div>
      </div>

      <div className={Styles.bannerimg}>
        <img src={bannerimg} alt="bannerimg" />
      </div>

      <div className="container">
        <div className={Styles.strategysection}>
          <h1 className={Styles.heading}>
            We combine{" "}
            <span className={Styles.highlight}>creativity and strategy</span> to
            help businesses move forward.
          </h1>
          <p className={Styles.description}>
          At Metasoft, we believe every business deserves a strong and meaningful digital presence that drives real results. That’s why we offer a complete range of services to help brands grow online, build genuine connections with their audience, and stay ahead in a fast-changing digital world. Whether it's creating engaging content for social media, building responsive websites and apps, crafting unique brand identities, or improving visibility through search engine optimization, we bring together creativity, strategy, and technical skill to deliver lasting impact. More than just a service provider, we aim to be your growth partner—working closely with you to understand your goals and bring your vision to life step by step.
          </p>
          <button className={Styles.ctaButton}>Let's Talk</button>
        </div>
      </div>

      <div className={Styles.bgservices}>
        <div className="container">
          <div className={Styles.servicesaln}>
            <div className={Styles.headergrid}>
              <p className={Styles.subTitlegrid}>Services We Provide</p>
              <h2 className={Styles.titlegrid}>
                We offer{" "}
                <span className={Styles.highlightgrid}>end–to–end</span>{" "}
                services <br />
                to support your digital journey
              </h2>
              <p className={Styles.descriptiongrid}>
                We provide everything from branding and design to SEO and IT
                support ensuring your digital presence is seamless, effective,
                and future-ready.
              </p>
            </div>
            <div>
              <button className={Styles.ctaButton}>Let's Talk</button>
            </div>
          </div>
<div
  className={`${Styles.grid} ${services.length === 6 ? Styles.threeCols : "3"}`}
>
  {services.map((service, idx) => (
    <div className={Styles.card} key={idx}>
      <img
        src={service.image}
        alt={service.title}
        className={Styles.imagegrid}
      />
      <h3 className={Styles.cardTitle}>{service.title}</h3>
      <p className={Styles.cardDescription}>{service.description}</p>
    </div>
  ))}
</div>
        </div>
      </div>

      <div className={Styles.processWrapper}>
        <div className="container">
          {/* Left Column */}
          <div className={Styles.servicesaln}>
            <div className={Styles.headergrid}>
              <p className={Styles.subTitlegrid}>Our Process</p>
              <h2 className={Styles.titlegrid}>
               Our to{" "}
                <span className={Styles.highlightgrid}>proven process </span>{" "}
                 grow your
 <br />
            brand on social media
              </h2>
              <p className={Styles.descriptiongrid}>
               Every post, reel, and reply is backed by strategy. Here’s the process we follow to make your brand visible, engaging, and results-driven.
              </p>
            </div>
            <div>
              <button className={Styles.ctaButton}>Let's Talk</button>
            </div>
          </div>
<div className={Styles.accordionSection}>

    <div className={Styles.accordionGrid}>
      {/* Left Side */}
      <div className={Styles.leftContent}>
        <img src={Processimg} alt="Social Media" className={Styles.accordionImage} />
        <div className={Styles.cardBoxx}>
          <p className={Styles.cardTitlee}>Want your content to look more professional?</p>
          <p className={Styles.cardTextt}>
            We also offer Branding services to ensure your content aligns with a strong visual identity.
          </p>
          <button className={Styles.cardButton}>Learn More</button>
        </div>
      </div>

      {/* Right Side - Accordion */}
      <div className={Styles.rightContent}>
        {accordionData.map((item, index) => (
          <div className={Styles.accordionItem} key={index}>
            <div
              className={Styles.accordionHeader}
              onClick={() => toggleAccordion(index)}
            >
              <h4>{item.title}</h4>
              <span>
  {activeIndex === index ? (
  <FaMinus />
) : (
 <svg width="28" height="28" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.0938 23.375H20.625V29.9062C20.625 30.0953 20.7797 30.25 20.9688 30.25H23.0312C23.2203 30.25 23.375 30.0953 23.375 29.9062V23.375H29.9062C30.0953 23.375 30.25 23.2203 30.25 23.0312V20.9688C30.25 20.7797 30.0953 20.625 29.9062 20.625H23.375V14.0938C23.375 13.9047 23.2203 13.75 23.0312 13.75H20.9688C20.7797 13.75 20.625 13.9047 20.625 14.0938V20.625H14.0938C13.9047 20.625 13.75 20.7797 13.75 20.9688V23.0312C13.75 23.2203 13.9047 23.375 14.0938 23.375Z" fill="#444444"/>
<path d="M37.8125 4.8125H6.1875C5.42695 4.8125 4.8125 5.42695 4.8125 6.1875V37.8125C4.8125 38.573 5.42695 39.1875 6.1875 39.1875H37.8125C38.573 39.1875 39.1875 38.573 39.1875 37.8125V6.1875C39.1875 5.42695 38.573 4.8125 37.8125 4.8125ZM36.0938 36.0938H7.90625V7.90625H36.0938V36.0938Z" fill="#444444"/>
</svg>

)}
              </span>
            </div>
            {activeIndex === index && (
              <div className={Styles.accordionContent}>
                <p>{item.content}</p>
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  </div>



      
         
        </div>
      </div>
      <div className={Styles.ctaBanner}>
  <div className={Styles.ctaOverlay}>
    <h2 className={Styles.ctaHeading}>
      Ready to take your online presence <br /> to the next level?
    </h2>
    <p className={Styles.ctaSubtext}>Let's build something great together.</p>
    <button className={Styles.ctaButton}>Let's Talk</button>
  </div>
</div>
<div>

 
  <div className="container">
    <div className={Styles.faqGrid}>
      
      {/* Left: Title */}
      <div className={Styles.faqTitleBlock}>
        <p className={Styles.faqLabel}>F.A.Q</p>
        <h2 className={Styles.faqHeading}>
          We’ve covered the most <br />
          common things people <span>ask us</span>
        </h2>
      </div>

      {/* Right: Accordion */}
      <div className={Styles.faqAccordion}>
        {faqData.map((item, index) => (
          <div className={Styles.accordionItem} key={index}>
            <div
              className={Styles.accordionHeader}
              onClick={() => setActiveFaq(index === activeFaq ? null : index)}
            >
              <h4>{item.question}</h4>
              <span>{activeFaq === index ? (
  <FaMinus />
) : (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.6875 12.75H11.25V16.3125C11.25 16.4156 11.3344 16.5 11.4375 16.5H12.5625C12.6656 16.5 12.75 16.4156 12.75 16.3125V12.75H16.3125C16.4156 12.75 16.5 12.6656 16.5 12.5625V11.4375C16.5 11.3344 16.4156 11.25 16.3125 11.25H12.75V7.6875C12.75 7.58437 12.6656 7.5 12.5625 7.5H11.4375C11.3344 7.5 11.25 7.58437 11.25 7.6875V11.25H7.6875C7.58437 11.25 7.5 11.3344 7.5 11.4375V12.5625C7.5 12.6656 7.58437 12.75 7.6875 12.75Z" fill="#444444"/>
    <path d="M20.625 2.625H3.375C2.96016 2.625 2.625 2.96016 2.625 3.375V20.625C2.625 21.0398 2.96016 21.375 3.375 21.375H20.625C21.0398 21.375 21.375 21.0398 21.375 20.625V3.375C21.375 2.96016 21.0398 2.625 20.625 2.625ZM19.6875 19.6875H4.3125V4.3125H19.6875V19.6875Z" fill="#444444"/>
  </svg>
)}</span>
            </div>
            {activeFaq === index && (
              <div className={Styles.accordionContent}>
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>

    </div>
  </div>


</div>
    </>
  );
};

export default SocialMediaMarketing;